import { ACTION_DEMO_START } from '../actions/demo';
import sidePanelReducer from './sidePanel';

export default function (state, action) {
    if (!state)
        state = {
            demoMode: false,
            pendingTasks: 0,
            sidePanel: null,
            isMobile: false,
            isDesktop: true,
            toasts: [],
            dialogs: [],
            activeLoaders: [],
        };

    switch (action.type) {
        case 'UI_BUSY':
            state = Object.assign({}, state, {
                pendingTasks: state.pendingTasks + 1,
            });
            break;
        case 'UI_FREE':
            state = Object.assign({}, state, {
                pendingTasks: state.pendingTasks - 1,
            });
            if (state.pendingTasks < 0) {
                console.warn('Negative pending tasks?!');
            }
            break;
        case 'UI_IS_MOBILE':
            state = {
                ...state,
                isMobile: action.isMobile,
                isDesktop: !action.isMobile,
            };
            break;
        case 'UI_IS_DESKTOP':
            state = {
                ...state,
                isDesktop: action.isDesktop,
                isMobile: action.isMobile,
            };
            break;
        case 'UI_TOAST_QUEUE':
            state = {
                ...state,
                toasts: [...state.toasts, action.message],
            };
            break;
        case 'UI_TOASTS_SET':
            state = {
                ...state,
                toasts: action.toasts,
            };
            break;
        case 'UI_TOAST_DONE':
            state = {
                ...state,
                toasts: state.toasts.filter((message) => message != action.message),
            };
            break;
        case 'DIALOG_SHOW':
            state = {
                ...state,
                dialogs: [action.dialog, ...state.dialogs],
            };
            break;
        case 'DIALOG_HIDE':
            state = {
                ...state,
                dialogs: state.dialogs.filter((d) => d.id != action.id),
            };
            break;
        case 'UI_LOADER_START':
            if (!state.activeLoaders.includes(action.id)) {
                state = {
                    ...state,
                    activeLoaders: [...state.activeLoaders, action.id],
                };
            }
            break;
        case 'UI_LOADER_STOP':
            if (state.activeLoaders.includes(action.id)) {
                state = {
                    ...state,
                    activeLoaders: state.activeLoaders.filter((id) => id != action.id),
                };
            }
            break;
        case ACTION_DEMO_START: {
            state = {
                ...state,
                demoMode: true,
                demoEventId: action.eventId
            };
            break;
        }
    }

    let sidePanel = sidePanelReducer(state.sidePanel, action);
    if (state.sidePanel !== sidePanel) {
        state = {
            ...state,
            sidePanel,
        };
    }

    return state;
}
